import { PasswordParamsResponse } from '@primatoo-ms-organization';

export class PasswordUtils {
  static generatePassword(params?: PasswordParamsResponse) {
    const numberChars = '0123456789';
    const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
    const specialChars = params?.specialChars || '?!';
    const passwordLength = params?.length || 8;

    const randPasswordCharsArray: string[] = [
      numberChars,
      upperChars,
      lowerChars,
      specialChars
    ];

    let randString = randPasswordCharsArray.map(sourceChars =>
      this.getRandChar(sourceChars)
    ).join('');

    randString = randString + this.getRandChar(lowerChars);

    /*randString have at least 1 number, 1 special char, 1 uppercase, 2 lowercase*/

    for (let i = 4; i < passwordLength; i++) {
      /*randomly add remaining chars*/
      const randChar = this.getRandChar(
        randPasswordCharsArray[this.getRandomIndex(0, randPasswordCharsArray.length - 1)]
      );
      randString += randChar;
    }

    return this.shuffleArray(randString.split('')).join('');
  }

  private static getRandomIndex(min: number, max: number) {
    return Math.floor(
      Math.random() * ((max - min) + 1)
    );
  }

  private static getRandChar(string: string): string {
    return string[
      Math.floor(
        Math.random() * (string.length)
      )
      ];
  }

  private static shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = this.getRandomIndex(0, array.length);
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }
}
